// extracted by css-extract-rspack-plugin
export default {"root":"AErelea44o7Kc8Wl","logo":"v19iYjOrnFEdExJO","links":"p99xponamg6rZ7HJ","link":"rN2PicYqwCUyH8ia","icon":"SMf4u7X5Zg2v5wiw"};